<template>
  <div class="table">
    <el-table :data="tableData" style="width: 100%" :header-cell-style="{
      backgroundColor: '#0E59CB',
      color: '#fff',
    }" :default-sort="{ prop: 'xz', order: 'descending' }" ref="singleTable" :highlight-selection-row="false"
      :row-class-name="tableRowClassName">
        <el-table-column prop="roomName" label="房屋" show-overflow-tooltip sortable>
      </el-table-column>

      <el-table-column prop="recordTime" show-overflow-tooltip label="巡检日期" sortable>
        <template slot-scope="scope">
          {{
      scope.row.recordTime.indexOf('00:00:00') == -1 ? scope.row.recordTime : scope.row.recordTime.slice(0, 10)
    }}
        </template>
      </el-table-column>


      <el-table-column show-overflow-tooltip sortable label="巡检状态">
        <template slot-scope="scope">
          {{
        scope.row.recordingStatus == 1 ? "正常" :
          scope.row.recordingStatus == 2 ? "异常" :
            scope.row.recordingStatus == 3 ? "验收" :
              scope.row.recordingStatus == 4 ? "未开门" :
                ""
      }}
        </template>
      </el-table-column>

      <el-table-column prop="recordingUser" show-overflow-tooltip sortable label="巡检人">
      </el-table-column>

      <!-- <el-table-column prop="inspectionLog" show-overflow-tooltip sortable label="巡检日志">
      </el-table-column> -->


      <el-table-column prop="zhwyFileEntityList" sortable label="巡检照片">
        <template slot-scope="scope">
          <span class="btn" @click="handerDetail(scope.row)">查看 </span>
        </template>
      </el-table-column>
    </el-table>

    <div class="yema">
      <Pagination style="margin-top: 10px" v-show="query.total > 0" :total="query.total" :limit.sync="query.pageSize"
        :page.sync="query.pageNum" round="false" :currentPageSize="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper" @pagination="changePage" />
    </div>
    <el-dialog title="照片" :visible.sync="dialogVisible" width="80%">
      <!-- <div class="box" v-if="currentObj.inspectionImg && currentObj.inspectionImg.length > 0">
        <div class="photo" v-for="(item, index) in currentObj.inspectionImg" :key="index"> -->

      <!-- <img class="photo" :src="item.url" alt="" /> -->

      <el-image v-for="(item, index) in currentObj.inspectionImg" :src="item.url"
        style="width: 240px; height: 240px;margin-right: 10px;" :preview-src-list="[item.url]">
      </el-image>


      <!-- </div> -->
      <!-- </div> -->

      <!-- <div v-else>暂无照片</div> -->
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/decoration";
import wyqyId from "../../config";
export default {
  data() {
    return {
      dialogVisible: false,
      currentObj: { zhwyFileEntityList: [] },
      tableData: [],
      query: {
        pageNum: 1,
        pageSize: 6,
      },
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      let params = {
        ...this.query,
        wyqyId: wyqyId,
      };
      api.zxxjquerylist(params).then((res) => {
        if (res.data.code == 200) {
          let _data = res.data.data.list || [];
          _data.forEach(v => {
            if (v.xjsj) {
              v.xjsj = v.xjsj.slice(0, 10)
            }
          });
          this.tableData = _data;
          console.log(this.tableData, "----------");
          this.query.total = res.data.data.total;
        }
      });
    },
    // 生产环境
    findCharIndex(str, char, num) {
      var index = str.indexOf(char);
      for (var i = 0; i < num - 1; i++) {
        index = str.indexOf(char, index + 1);
      }
      let endurl =
        "http://182.140.144.130:9000" + str.substr(index, str.length);
      return endurl;
    },
    changePage(val) {
      this.query.pageNum = val;
      this.initPage();
    },
    handerDetail(row) {
      this.currentObj = row;
      this.dialogVisible = true;
    },
    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  position: relative;
  margin-top: 20px;
  height: 420px;
}

.yema {
  position: absolute;
  bottom: 30px;
  right: 0;
}

::v-deep.el-table .warning-row {
  background-color: #0f53a5 !important;
  color: #fff !important;
}

::v-deep.el-table .success-row {
  background-color: #193a5c !important;
  color: #fff !important;
}

::v-deep.el-table tbody tr:hover>td {
  background-color: unset !important;
}

::v-deep.el-table__body {
  border-color: #0f53a5 !important;
}

.el-table {
  border-bottom: 1px solid #1763e8;
  border-right: 1px solid #1763e8;
  margin: 0 auto;
}

::v-deep.el-table th {
  border: 1px solid #1763e8 !important;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep.el-table td {
  border: 1px solid #1763e8;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}

::v-deep .el-table__empty-text {
  color: #fff;
}

:v-deep .el-button {
  padding: 0 !important;
}

.btn {
  color: #1763e8;
  cursor: pointer;
}

.box {
  display: flex;
  flex-wrap: wrap;
}

.photo {
  width: 280px;
  height: 330px;
  margin-right: 5px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #f6f7f6;
}
</style>
